export default __webpack_public_path__ + "static/the-propane-home-bg-en-1a412d6c63935155d9337ecfc802c651.jpg";